import {Component, OnDestroy, OnInit} from '@angular/core';
import {finalize, Subject, takeUntil} from 'rxjs';
import {environment} from '../../environments/environment';
import {FormsModule} from '@angular/forms';
import {LeadService} from '../../services/lead.service';
import {GeneralService} from '../../services/general.service';
import {ToastService} from '../toast/toast.service';

@Component({
  selector: 'app-partners',
  imports: [
    FormsModule
  ],
  templateUrl: './partners.component.html',
  styleUrl: './partners.component.scss'
})
export class PartnersComponent implements OnDestroy {
  onDestroy$ = new Subject<boolean>();

  NUM_SPACES = environment.NUM_SPACES
  NUM_CITIES = environment.NUM_CITIES
  NUM_MEMBERS = environment.NUM_MEMBERS

  name: string | null = null
  email: string | null = null
  phone: string | null = null
  placeName: string | null = null
  placeLocation: string | null = null

  submitted = false

  constructor(private toast: ToastService,
              private leadService: LeadService,
              private generalService: GeneralService) {
  }

  ngOnDestroy() {
    this.onDestroy$.next(true);
    this.onDestroy$.complete();
  }

  submit() {
    if (!this.name) return
    if (!this.email) return
    if (!this.phone) return
    if (!this.placeName) return
    if (!this.placeLocation) return

    const topic = "Partner Inquiry"
    const name = this.name;
    const email = this.email;
    const phone = this.phone;
    const placeName = this.placeName
    const placeLocation = this.placeLocation

    const message =
      `[${topic}] Connect with our partnerships team` +
      `\n\nName: ${name}` +
      `\n\nEmail: ${email}` +
      `\n\nPhone: ${phone}` +
      `\n\nPlace name: ${placeName}` +
      `\n\nPlace location: ${placeLocation}`

    this.leadService.partner(name, email, phone, placeLocation);

    this.submitted = true
    this.generalService.createContact(name, email, message).pipe(
      takeUntil(this.onDestroy$),
      finalize(() => this.submitted = false))
      .subscribe(() => {
        this.toast.success(`Thanks for reaching out. We'll be in touch soon!`);

        // Reset form
        this.name = null
        this.email = null
        this.name = null
        this.phone = null
        this.placeName = null
        this.placeLocation = null
      });
  }

}
